export function useTableTitle() {
  return "To depict a commodity on the chart, please, select it in the header of the table";
}
